export default __webpack_public_path__ + "cf87ef2961e5318af28c99b950242910.png";